<ng-container [formGroup]="terminalForm">
  <h3 class="col-12 m-0">Date terminal card</h3>
  <!-- <input type="text" class="hidden">
  <input type="password" class="hidden">
  <div class="col-12">
    <span class="font-bold block mb-2">ID banca</span>
    <input
      autocomplete="off"
      class="w-full"
      type="text"
      pInputText
      formControlName="bankId"
      placeholder="ID banca"
    >
  </div> -->

  <div class="col-12">
    <span class="font-bold block mb-2">Provider</span>
    <p-dropdown
      appendTo="body"
      styleClass="w-full"
      placeholder="Selectează un provider"
      optionLabel="name"
      optionValue="id"
      formControlName="providerId"
      [options]="providers()"
      [loading]="loadingProviders()"
    ></p-dropdown>
    @let provider = terminalForm.get("providerId");
    @let providerErrors = provider?.errors;
    @if (provider?.dirty) {
      @if (providerErrors?.["required"]) {
        <small class="text-red-500">Selectează un provider</small>
      }
    }
  </div>

  <div class="col-12">
    <span class="font-bold block mb-2">ID Terminal</span>
    <input
      autocomplete="off"
      class="w-full"
      type="text"
      pInputText
      formControlName="terminalIdentifier"
      placeholder="ID Terminal"
    >
  </div>

  <div class="col-12">
    <span class="font-bold block mb-2">ID Merchant</span>
    <input
      autocomplete="off"
      class="w-full"
      type="text"
      pInputText
      formControlName="merchantIdentifier"
      placeholder="ID merchant"
    >
  </div>
</ng-container>